module.exports = "/static/assets/16bc89960360c58e0f8212b8a1eb94f0.png";